import { useQuery } from '@tanstack/react-query';

import { getUnreadChats } from '../api';

export const UNREAD_CHATS_QUERY_KEY = ['chats', 'unread'];

export const useUnreadChatsQuery = () => {
  return useQuery({
    queryKey: UNREAD_CHATS_QUERY_KEY,
    queryFn: getUnreadChats,
    staleTime: Infinity,
  });
};
